<section class="faq pageHeight" id="faq">
  <h2 class="section-title m-0" [innerHTML]=" 'faq.title' | translate "></h2>
  <h3 class="section-desc fw-bold">{{"faq.para" | translate}}</h3>
  <div class="overflow-wrap">
  <div class="box" *ngFor="let item of items">
    <h2 class="text-uppercase head-item mb-2">{{ item.heading | translate }}</h2>
    <p>{{ item.content | translate }}</p>
  </div>
  </div>
  <div (click)="showWidget('home');"  class="btn btn-primary animation py-3 font-20 fw-semibold mt-4 d-inline-block d-lg-none">{{'banner.buy_node' | translate }}</div>
  <img src="/assets/images/png/faq_laptop.png" alt="laptop" class="img-fluid laptop" />
</section>
